// extracted by mini-css-extract-plugin
export default {"container":"SetupSecurity_container__pTj3A","row":"SetupSecurity_row__ErhmP"};